<template>
  <div>
      <div class="default-container d-flex flex-column">
          <div class="row align-items-center mb-3">
              <div class="col-md-6 col-12">
                  <h4 class="def-title">Incluir Devolução</h4>
              </div>
              <div class="col-md-6 col-12">
                  <v-button v-show="!isView" label="Salvar" title="" icon="fa-save" :nb-btdef="true" class="float-right" @click="handleSave"></v-button>
                  <v-button v-if="isView && vdevol.nfDevolucao && !vdevol.nfDevolucao.autorizada" label="Excluir" title="" icon="fa-trash" class="float-right"  @click="apiDelete"></v-button>
                  <v-button label="Retornar" icon="fa-arrow-left" class="float-right" @click="closeForm"></v-button>
              </div>
          </div>

          <validation v-if="errmessages.length" :messages="errmessages"></validation>

          <label-title title="Dados da Devolução" v-if="isView"></label-title>
          <div class="row" v-if="isView">
              <div class="col-md-3 col-6">
                  <v-label :metadata-field="metadata.vdevol.codvdevol"></v-label><br>
                  <span class="lbl">{{ vdevol.codvdevol }}</span>
              </div>
              <div class="col-md-3 col-6">
                  <v-label :metadata-field="metadata.vdevol.data"></v-label><br>
                  <span class="lbl">{{ vdevol.data | formatDataHora }}</span>
              </div>
              <div class="col-md-3 col-6">
                  <v-label label="Operador"></v-label><br>
                  <span class="lbl">{{vdevol.operador}}</span>
              </div>
              <div class="col-md-2 col-6">
                  <v-label label="Nota de Devolução"></v-label><br>
                  <span class="lbl">{{ vdevol.nfDevolucao.nf }}</span>
                  <span class="badge badge-danger" v-if="vdevol.nfDevolucao.enviar">NF Devolução Não Enviada</span>
                  <span class="badge badge-success" v-if="vdevol.nfDevolucao.autorizada">Nota Autorizada</span>
              </div>
              <div v-if="vdevol.nfDevolucao.enviar" class="col-md-3 col-6 ml-auto mt-2">
                  <v-button label="Autorizar NF" @click="handleAutorizaNF(vdevol.nfDevolucao.codnf)" :nb-btdef="true" title="" icon="fa-rss-square" ></v-button>
              </div>
          </div>
          <div class="row" v-if="isView">
              <div class="col-md-12 col-12">
                  <hr>
              </div>
          </div>

          <label-title title="Dados da Venda"></label-title>

          <div class="row">
              <div class="col-md-3 col-6">
                  <v-label :metadata-field="metadata.vdevol.codpedv"></v-label><br>
                  <span class="lbl">{{ vdevol.npedido }}</span>
              </div>
              <div class="col-md-3 col-6">
                  <v-label label="Data da Venda"></v-label><br>
                  <span class="lbl">{{ vdevol.data | formatDataHora }}</span>
              </div>
              <div class="col-md-3 col-6" v-if="vdevol.nfVenda">
                  <v-label label="Nota de Venda"></v-label><br>
                  <span class="lbl">{{ vdevol.nfVenda.nf }}</span>
              </div>
              <div class="col-md-3 col-6">
                  <v-label label="Operador"></v-label><br>
                  <span class="lbl">{{vdevol.operador}}</span>
              </div>
          </div>
          <div class="row" v-if="vdevol.part">
              <div class="col-md-3 col-6 pl-3">
              <v-label :metadata-field="metadata.vdevol.codpart" ></v-label><br>
              <span class="lbl">{{ vdevol.part.nome }}</span>
              </div>
              <div class="col-md-3 col-6 pl-3">
                  <v-label :metadata-field="metadata.part.cnpjcpf" ></v-label><br>
                      <span class="lbl">{{this.$formatCPF(vdevol.part.cnpjcpf)}}</span>
              </div>
              <div class="col-md-3 col-6">
                  <v-label :metadata-field="metadata.part.tppessoa" v-if="vdevol.part.pessoaFisica"></v-label><br>
                  <span class="lbl">{{vdevol.part.pessoaFisica ? 'PESSOA FÍSICA':''}}</span>
              </div>
              <div class="col-md-3 col-6">
                  <v-label :metadata-field="metadata.mun.nomemun"></v-label><br>
                  <span class="lbl">{{vdevol.part.codmun}}</span> <!--TRAZER NOME DO MUNINCIPIO-->
              </div>
              <div class="col-md-3 col-6 ">
                  <v-label :metadata-field="{label:'UF'}"></v-label><br>
                  <span class="lbl">{{vdevol.part.uf}}</span>
              </div>
              <div class="col-md-3 col-6">
                  <v-label :metadata-field="metadata.part.cep"></v-label><br>
                  <span class="lbl">{{vdevol.part.cep }}</span>
              </div>
              <div class="col-md-3 col-6">
                  <v-label :metadata-field="metadata.part.ende"></v-label><br>
                  <span class="lbl">{{vdevol.part.endereco}}</span>
              </div>
              <div class="col-md-3 col-6">
                  <v-label :metadata-field="metadata.part.endenr"></v-label><br>
                  <span class="lbl">{{vdevol.part.nr}}</span>
              </div>
              <div class="col-md-3 col-6">
                  <v-label :metadata-field="metadata.part.endecomp"></v-label><br>
                  <span class="lbl">{{vdevol.part.complemento}}</span>
              </div>
          </div>
          <label-title v-if="avisoSerie55" title="Série de nota fiscal 55"></label-title>
          <div class="row mb-5" v-if="avisoSerie55">
            <div class="col-6">
                <warnings :messages="['Cadastre uma série de NF modelo 55 para efetivar a devolução de venda!']"></warnings>
            </div>
            <div class="w-100"></div>
            <div class="col-6">
                <v-button ref="buttonSerie" label="Cadastrar Serie" title="" :nb-btdef="true" @click="handleShowSerie"></v-button>
            </div>
          </div>
          <label-title v-if="isView" title="cliente"></label-title>
          <label-title v-else title="Informe o cliente"></label-title>
          <div class="row mb-5">
            <div v-if="!isView" class="col-6">
              <warnings :messages="['Selecione um cliente cadastrado ou cadastre um novo cliente!']"></warnings>
            </div>
            <div class="w-100"></div>
            <div class="col-6" v-if="vdevol.part">
              <input-part name="Cliente" ref="part" v-model="vdevol.part.codpart" :add-button="true" :disabled="isView" :varejo="true"></input-part>
            </div>
          </div>
          <label-title v-if="!isView" title="Produtos a Devolver"></label-title>
          <label-title v-else title="Produtos Devolvidos"></label-title>
          <div class="row" v-show="!isView">
            <div class="col-6">
              <warnings :messages="['Informe o tipo da devolução e em seguida selecione os produtos devolvidos!']"></warnings>
            </div>
            <div class="w-100"></div>
            <form-field :disabled="isView" v-model="devTipo" style="font-size:15px!important" type="select" :metadata="{label:'Tipo da Devolução', options:[{id:1, text:'Devolução Parcial'}, {id:2, text:'Devolução Total'}]}" col="4"></form-field>
          </div>
          <div class="mainbox" v-for="(item,index) in vdevol.itens" :key="index">
              <!-- <div class="mark-gray"></div> -->
              <div class="box">
                  <div class="row">
                      <div class="col-auto justify-content-center">
                          <div class="ml-3 mt-4">
                              <input type="checkbox" style="transform: scale(1.5); cursor: pointer;"
                              @change="handleChangeCheck(item, index)" :disabled="devTipo== ''" v-model="item.check">
                          </div>
                      </div>
                      <div class="col-5">
                          <span class="lbl-edit">Descrição</span><br>
                          <span class="data-list"> {{ item.descricao }} {{ item.linha }} {{ item.coluna }} </span>
                      </div>
                      <div class="col-2 text-center">
                          <span class="lbl-edit">{{isView? 'Qtd Devolvida' : 'Qtd'}}</span><br>
                          <span class="data-list">{{item.qt|formatValue(2, true)}} {{item.uni}} x R$ {{item.valor| formatValue(2, true)}}</span>
                      </div>
                      <div class="col-2 text-center pb-0 mb-0" v-if="!isView">
                          <div>
                              <span class="lbl-edit">Qtd Devolver</span>
                          </div>
                          <!-- <div class="mt-2 d-flex flex-column align-items-start" style="text-align: justify!important"><form-field v-model.number="item.qtdev" @input="handleEditQtDev" class="d-f-validation" :disabled="check.find(e=> e==item) != item" :v-errors="errros" :required="true" :v-validate.immediate="{required: true}" :precision="2" :enabled="check.find(e=> e == item) == item" type="value"><span v-show="item.errors" class="mt-0 p-0 justify-content-start text-left" style="word-break: break-all; font-size:12px; color:#f50000">{{item.errors}}</span></form-field></div> -->
                          <div class="d-flex flex-column align-items-start">
                              <span class="d-flex">
                                  <form-field v-model.number="item.qtdev" @input="handleEditQtDev" class="d-f-validation"  :required="true" :precision="2" type="value" :disabled="!item.check">
                                      <span v-show="item.errors" class="mt-0 p-0 justify-content-start text-left" style="word-break: break-all; font-size:12px; color:#f50000">{{item.errors}}</span>
                                  </form-field>
                              </span>
                          </div>
                      </div>
                      <div class="col-2 text-center">
                          <div>
                              <span class="lbl-edit">Valor Total</span>
                          </div>
                          <span class="data-list">
                              {{isView ? item.total : item.totdev|formatValue(2, true)}}
                          </span>
                      </div>
                  </div>
              </div>
          </div>

          <div class="row">
              <div class="col-md-3 text-center ml-auto">
                  <span class="data-list">Total da Devolução
                      <strong v-if="!isView" class="col-2">{{ totalDev | formatValue(2, true) }}</strong>
                      <strong v-else class="col-2">{{ vdevol.total | formatValue(2, true) }}</strong>
                  </span>
              </div>
          </div>

          <label-title  class="mt-3 " title="Forma De Pagamento"></label-title>
          <div class="row" >
              <form-field  v-model="vdevol.lancamentodevol" placeholder="Selecione" type="select"
              :metadata="{label:'Forma de Pagamento', options:[{id:'D', text:'Dinheiro'},{id:'C', text:'Crédito Loja'}]}" col="2" :disabled="isView"></form-field >
          </div>
      </div>


    <div v-if="showModalSerie" class="modal nb-modal-mask" style="display:block; z-index: 1 !important;">
        <Trap>
        <div class="modal-dialog modal-dialog-centered modal-md" role="document" style="max-width: 90%; width: 60% !important;overflow-y: initial !important;">
            <div class="modal-content">
                <div class="modal-body pt-3" style="height: 90vh!important; max-height: 100%; overflow-y: auto;">
                    <serienf-form :crud="crudSerie" v-on:closeform="closeSerie"></serienf-form>
                </div>
            </div>
        </div>
        </Trap>
    </div>

  </div>
</template>

<script>
import PedidoAddlist from '../forms/pedido-addlist'
import { SysVars } from '../main'
import { apiORDSpost, apiORDSdelete } from '../shared/api-functions'
import SerienfForm from '../forms/serienf-form'
export default {
  data(){
      return{
          vdevol: '',
          metadata : this.$store.getters.getEntities.metadata,
          devTipo: '',
          totalDev : 0,
          errorClienteValCPF:'',
          errorClienteVal:'',
          crudText:'',
          errmessages: [], // Armazena as mensagens de validações do servidor para mostrar na tela
          showModalSerie: false,
          avisoSerie55: false,
      }
  },
  computed:{
      isView(){
          return (this.crud == SysVars.crudView)
      },
      crudSerie(){
        return SysVars.crudInsert
      },
  },
  watch:{
      devTipo(val){
          if(val == '' ||  null){
              this.vdevol.itens.forEach((e,i)=> {

                  this.$set(this.vdevol.itens[i], 'check', false)
                  this.$set(this.vdevol.itens[i], 'qtdev', 0)
                  this.$set(this.vdevol.itens[i], 'totdev', 0)

               })
          }
          if(val == '1'){
               this.vdevol.itens.forEach((e,i)=> {
                  this.$set(this.vdevol.itens[i], 'check', false)
                  this.$set(this.vdevol.itens[i], 'qtdev', 0)
                  this.$set(this.vdevol.itens[i], 'totdev', 0)
                  this.totalDev = 0
                  this.vdevol.itens.find((e,i)=>{
                  this.totalDev = (e.valor * e.qtdev) + this.totalDev
               })
               })
          }
          if(val == '2'){
              this.vdevol.itens.forEach((e, i) => {
                  this.$set(this.vdevol.itens[i], 'check', true)
                  this.$set(this.vdevol.itens[i], 'qtdev', e.qt)
                  this.$set(this.vdevol.itens[i], 'totdev', e.qtdev * e.valor)
              })
              this.totalDev = 0
          }
          this.calcDev()
      }

  },
  props:{
      index:'',
      crud:'',

  },
  components:{
      PedidoAddlist, SerienfForm
  },
  methods:{
      handleShowSerie() {
        this.showModalSerie = true
      },
      closeSerie(esp) {
        this.showModalSerie = false
        if (esp == '55')
            this.avisoSerie55 = false
      }, 

      calcDev(){
          this.totalDev = 0
          let total = 0
          this.vdevol.itens.find(e=>{
              total = (e.valor * e.qtdev) + total
          })
          return this.totalDev = total
      },

      handleChangeCheck (item,i) {
          if(item.check == false){
              this.$set(this.vdevol.itens[i],'qtdev', 0)
              this.calcDev()
              this.vdevol.itens[i].errors = ''
              this.$set(this.vdevol.itens[i],'totdev', 0)
              this.$set(this.vdevol.itens[i], 'check', false)
              this.totalDev = this.vdevol.itens[i].totdev + this.totalDev
              this.calcDev()
          }
      },
      handleEditQtDev(evt){
          this.vdevol.itens.map((e,i)=>{
              if(e.qtdev > e.qt){
                  this.$set(this.vdevol.itens[i],'errors', 'Qtd a devolver não pode ser maior que qtd do item')
              } else{
                  this.$set(this.vdevol.itens[i],'errors', '')

              }

          this.$set(this.vdevol.itens[i], 'totdev', e.qtdev * e.valor)

          if(e.qtdev == 0){
                  this.$set(this.vdevol.itens[i], 'totdev', 0)
                  this.totalDev = 0

              }
          })
          this.calcDev()
      },

      closeForm(){
          this.$emit('closeform', this.vdevol.codvdevol)
      },

      handleAutorizaNF(){
          return this.$router.push('/nf/' + this.vdevol.nfDevolucao.codnf + '?tipo=devolucao')
      },

      handleSave(){
          this.errmessages = []
          let isValid = true
          let isValidIt = true

          if (this.avisoSerie55) {
            this.$erpToastError(`Cadastre uma série de NF para prosseguir`)
            return
          }


          if (this.vdevol.obrigaDadosCliente || this.vdevol.lancamentodevol == 'C')
              if (!this.vdevol.part.codpart) {
                  isValid = false
                  this.$erpToastError(`Selecione ou cadastre um cliente para concluir`)
                  return
              }

          this.vdevol.itens.map(e=>{
             if(e.errors == ''|| e.errors == null){
                 isValidIt = true
             }
             else{
                  isValidIt = false
                  this.$erpToastError(`Por favor, corrija os campos em destaque para continuar`)
             }
          })

          if(this.totalDev == 0){
              isValid = false
              this.$erpToastError(`Valor da devolução não pode estar zerado`)
          }
          if(isValid & isValidIt){
              this.apiPost()
          }
      },

      async loadData(){
          if (this.crud == SysVars.crudView) {
              await this.$store.dispatch('loadVdevol', {id:this.index})
          }
          else {
              await this.$store.dispatch('loadVdevolPed', {id:this.index})
          }
          this.vdevol = this.$store.getters.getVdevol
          if (this.vdevol.part.cnpjcpf == 'CONSUMIDOR') {
              this.vdevol.part.codpart = null
          }

          if (this.crud != SysVars.crudView && this.vdevol.nfVenda && !this.vdevol.serienf) {
            this.avisoSerie55 = true
          }

          this.$nextTick(function () {
              jQuery('[data-toggle="tooltip"]').tooltip()
              this.unwatch = false
          })

      },

      async apiPost(){
          //efetuaGravação
          var modulo = 'varejo/devolucao'
          let sendData = {vdevol:{}}
               // CAMPOS REFATORADOS PARA ENVIO DO METODO POST
              sendData.vdevol.codpedv= this.vdevol.codpedv
              sendData.vdevol.codpart = this.vdevol.part.codpart
              // sendData.vdevol.pessoaFisica= this.vdevol.part.pessoaFisica,
              // sendData.vdevol.cnpjcpf= this.vdevol.part.cnpjcpf,
              // sendData.vdevol.nome= this.vdevol.part.nome,
              // sendData.vdevol.endereco= this.vdevol.part.endereco,
              // sendData.vdevol.nr= this.vdevol.part.nr,
              // sendData.vdevol.bairro= this.vdevol.part.bairro,
              // sendData.vdevol.cep= this.vdevol.part.cep,
              // sendData.vdevol.complemento= this.vdevol.part.complemento,
              // sendData.vdevol.codmun= this.vdevol.part.codmun,
              // sendData.vdevol.uf= this.vdevol.part.uf,
              sendData.vdevol.codnates= null
              sendData.vdevol.lancamentodevol = this.vdevol.lancamentodevol
              sendData.vdevol.codvabertura = this.vdevol.codvabertura
              sendData.vdevol.itens = this.vdevol.itens
              // sendData.vdevol.pedvit.map(e=> {
              //     e.valor = e.vlr
              //     delete e.vlr
              //     })

          let metodo = 'post'
          let update = false

          if(this.crud == SysVars.crudUpdate){
              update = true
          }
          const data = await apiORDSpost(this.$store, modulo, sendData, metodo)
          console.log(data)
          if (data.errmessages) {
              this.errmessages = data.errmessages
              this.$erpToastError('Alguns erros precisam ser corrigidos.')
          } else {
              if(update){
                  this.$erpToastUpdated()
                  this.$router.push('/varejo/devolucaolist')
              } else{
                  this.$erpToastInserted()
                  this.$router.push('/varejo/devolucaolist')
              }
              this.errmessages = []
          }
      },
      async apiDelete(){
          var modulo = 'varejo/devolucao/' + this.index
          const data = await apiORDSdelete(this.$store, modulo)
          this.$erpToastDeleted()
          this.closeForm()
      },
      situation(item){
           return item == 'C' ? 'badge-danger' : 'badge-success'
      },

  },
  created(){
      this.loadData(),
      this.$scrollTo(0);
  }

}
</script>

<style>
.d-f-hover-link:hover{
color: #5788fd!important;
cursor: pointer;
}
</style>




// WEBPACK FOOTER //
// src/forms-varejo/varejo-devolucao-form.vue